module.exports = __webpack_public_path__ + "img/bgr-easter.174a8286.svg";